import React, { FunctionComponent, useMemo } from 'react';

import dateToString from '@ps-int/ufo-helpers/lib/date/date-to-string';
import { Text } from '@yandex-360/orb-components/dist/components/Text';
import cn from 'classnames';

import { i18n, i18nMonthsGenitive, i18nWeekDays } from '../../../../../../shared/helpers/i18n';
import { useIsOneColLayout } from '../../../../hooks';
import { ConferenceHistoryItem } from '../../../../types';
import { Conference } from '../conference';
import styles from './styles.css';

interface ConferencesForDayProps {
    conferences: ConferenceHistoryItem[];
}

export const ConferenceForDay: FunctionComponent<ConferencesForDayProps> = ({ conferences }) => {
    const [dateNumber, weekDay, isToday, monthNominative] = useMemo(() => {
        const date = new Date(conferences[0].startedAt);
        return [
            date.getDate(),
            i18nWeekDays()[date.getDay()],
            date.toLocaleDateString() === new Date().toLocaleDateString(),
            i18nMonthsGenitive()[date.getMonth()],
        ];
    }, [conferences]);
    const date = useMemo(() => new Date(conferences[0].startedAt), [conferences]);
    const isOneColLayout = useIsOneColLayout();
    return (
        <>
            <tr className={(styles.conferencesForDay, cn({ [styles.oneColLayout]: isOneColLayout }))}>
                {!isOneColLayout && (
                    <td className={styles.left}>
                        <Text
                            as="h3"
                            typography="heading-sm"
                            aria-label={`${dateNumber} ${monthNominative}`}
                            className={styles.dateNumber}
                        >
                            {dateNumber}
                        </Text>
                        <Text typography="body-md-regular" color="secondary">
                            {weekDay}
                        </Text>
                        {isToday && (
                            <Text typography="body-md-medium" color="brand">
                                {i18n('conferences-history', 'today')}
                            </Text>
                        )}
                    </td>
                )}
                {isOneColLayout && (
                    <Text className={styles.date} color={isToday ? 'brand' : 'secondary'} typography="body-lg-medium">
                        {dateToString(date, 'D mmmm', [], i18nMonthsGenitive())},{' '}
                        {isToday ? i18n('conferences-history', 'today') : weekDay}
                    </Text>
                )}
                <td className={styles.right}>
                    <ul className={styles.confs}>
                        {conferences.map((conference) => {
                            return <Conference conference={conference} key={conference.shortUrlId} />;
                        })}
                    </ul>
                </td>
            </tr>
        </>
    );
};
